s
<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />
          <!-- /Page Header -->

          <!-- Settings Menu -->
          <leads-tabs></leads-tabs>
          <!-- /Settings Menu -->

          <div class="row">
            <individual-sidebar></individual-sidebar>

            <div class="col-xl-9 col-lg-12">
              <!-- Info -->
              <div class="card">
                <div class="card-body">
                  <form @submit.prevent="submitForm">
                    <div class="border-bottom mb-3">
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label"> Visiting Card </label>
                            <input type="text" class="form-control" />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label"> Job Type </label>
                            <multiselect
                              v-model="selectedProject"
                              :options="projects"
                              track-by="name"
                              label="name"
                              placeholder="Select Job Type"
                            >
                            </multiselect>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label">Profession</label>

                            <multiselect
                              v-model="selectedProject"
                              :options="projects"
                              track-by="name"
                              label="name"
                              placeholder="Select Project"
                            >
                            </multiselect>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="col-form-label">Date Of Birth</label>
                            <Datepicker
                              :range="false"
                              :clearable="true"
                              placeholder="Select a date"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label">
                              Birthday Greetings
                            </label>
                            <select name="" id="" class="form-control">
                              <option disabled :selected="true">
                                Select..
                              </option>
                              <option>SMS</option>
                              <option>Email</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label"> Gender </label>
                            <select name="" id="" class="form-control">
                              <option disabled :selected="true">
                                Select..
                              </option>
                              <option>Male</option>
                              <option>Female</option>
                              <option>Others</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="mb-3">
                            <label class="form-label"> Marital Status </label>
                            <select name="" id="" class="form-control">
                              <option disabled :selected="true">
                                Select..
                              </option>
                              <option>Married</option>
                              <option>Unmarried</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="btn-list">
                      <button type="submit" class="btn btn-primary">
                        Save Changes
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <!-- /Info -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
    Datepicker,
  },
  data() {
    return {
      title: "Personal Information",
      selectedProject: {},
      projects: [
        { id: 1, name: "Project 1" },
        { id: 2, name: "Project 2" },
        { id: 3, name: "Project 3" },
      ],
      selectedAssignTo: {},
      assignPersons: [
        { id: 1, name: "Assign To 1" },
        { id: 2, name: "Assign To 2" },
        { id: 3, name: "Assign To 3" },
      ],
      selectedAdditionalAssignTo: {},
    };
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
